import React from 'react';
import styled from '@emotion/styled';

import PageTitle from '../../../common/PageTitle';
import Button from '../../../common/Button';
import Radios from '../../../common/Radios';
import { PHYSICAL_SET_ORDER_ACTION_TYPES } from '../../../../config';
import Table from '../../../common/Table';
import Select from '../../../common/Select';

const Wrapper = styled('div')`
  .action-types-wrapper {
    margin-left: 42px;
    margin-top: 10px;
  }

  .set-choosing {
    margin-left: 42px;
    margin-top: 30px;
    padding-bottom: 34px;
    font-size: 14px;
    cursor: pointer;
    color: #7e57c2;

    i {
      margin-right: 4px;
    }

    &.disabled {
      color: #cacaca;
      cursor: auto;
    }
  }

  .table {
    min-width: 1000px;
  }

  .actions-group {
    display: flex;
    justify-content: space-between;
    margin: 0 -20px;
  }

  .actions-group-item {
    margin: 0 20px;
    min-width: 360px;
    &:first-child {
      min-width: 270px;
    }

    .form-inline {
      margin-bottom: 22px;
    }
  }

  .image-td {
    width: 70px;
    padding-right: 5px !important;
    padding-left: 14px !important;

    .image-block {
      width: 45px !important;
      height: 45px !important;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
  }

  .shortname-td {
    max-width: 300px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    padding-right: 40px;
    color: #323a46;

    .ids-span {
      font-size: 12px;
      color: #98a6ad;
      cursor: pointer;
      font-weight: normal;
    }
  }

  .set-items-wrapper {
    width: 100%;
    padding-right: 30px;

    > div {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #ebebeb;
      padding-bottom: 10px;
      margin-bottom: 10px;

      &:last-child {
        border-bottom: none;
        padding-bottom: 0;
        margin-bottom: 0;
      }
    }

    .shortname-td {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #323a46;
      padding: 4px 0;
    }
  }

  .quantity-picker-wrapper {
    width: 100px;
    justify-content: left;

    .quantity-static-value {
      margin-right: 5px;
      margin-left: 5px;
      width: auto; !important;
    }
  }

  .quantity-picker {
    justify-content: center;
    width: auto;

    .quantity-static-value {
      flex: none;
      color: #323a46;
    }

    .quantity-control {
      border: 1px solid #7e57c2;
      border-radius: 15px;
      height: 18px;
      width: 18px;
      display: flex;
      justify-content: center;
      margin: 0 15px;
      flex: none;

      i {
        font-size: 12px;
        margin: 0;
      }
    }
  }

  .quantity-td {
    width: 190px;
  }

  .set-td {
    width: 40%;
    padding-right: 30px;
  }

  .border-bottom {
    border-bottom: 1px solid #ebebeb;
  }

  .shortname-item {
    display: flex;

    .shortname-td {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #323a46;
      padding: 4px 0;
    }

    .quantity-item {
      flex: 1;
      margin-left: 20px;
      color: #72747b;
    }
  }

  table th:last-of-type {
    text-align: center;
  }

  .quantity-td {
    padding: 4px 20px;
  }

  .item-inner-table {
    &:first-child {
      > td {
        border-top: none;
      }
    }

    > td {
      padding-left: 0;
      padding-right: 0;
    }
  }

  @media (max-width: 1320px) {
    .actions-group {
      flex-direction: column;
    }
    .set-choosing {
      margin-top: 15px;
    }
    .actions-group-item {
      margin-top: 24px;
      max-width: 320px;
      .form-inline {
        margin-bottom: 12px;
      }
    }
  }
`;

const DesktopComponent = ({
  action,
  setAction,
  currentSet,
  data,
  loading,
  handleSaveTask,
  handleChooseSets,
  quantity,
  warehouseOptions,
  warehouseCode,
  handleChangeWarehouseCode,
}) => {
  return (
    <>
      <PageTitle title="Новое задание" />

      <Wrapper className="card">
        <div className="card-body">
          <div className="actions-group">
            <div className="actions-group-item">
              <div className="form-inline">
                <div className="form-group">
                  <span className="number-circle mr-2">1</span>
                  <span>Укажите тип задания</span>
                </div>
              </div>
              <div className="action-types-wrapper">
                <Radios
                  id="action"
                  name="action"
                  data={PHYSICAL_SET_ORDER_ACTION_TYPES}
                  currentValue={action}
                  onChange={setAction}
                />
              </div>
            </div>

            <div className="actions-group-item">
              <div className="form-inline">
                <div className="form-group">
                  <span className="number-circle mr-2">2</span>
                  <span>Выберите склад</span>
                </div>
              </div>
              <div className="action-types-wrapper">
                <Select
                  id="warehouseCode"
                  placeholder="Выберите склад"
                  options={warehouseOptions}
                  value={warehouseCode}
                  onChange={(value) => handleChangeWarehouseCode(value)}
                  isOptionDisabled={(option) => option.isOptionDisabled}
                />
              </div>
            </div>

            <div className="actions-group-item">
              <div className="form-inline">
                <div className="form-group">
                  <span className="number-circle mr-2">3</span>
                  <span>Выберите комплект и количество</span>
                </div>
              </div>
              <div
                className={`set-choosing ${currentSet && quantity ? 'disabled' : ''}`}
                onClick={!currentSet ? handleChooseSets : () => false}
              >
                <i className="fe-plus"></i> Выбрать комплект
              </div>
            </div>
          </div>

          {currentSet ? <Table data={data} /> : null}
        </div>
      </Wrapper>

      {currentSet && quantity ? (
        <div className="d-flex justify-content-between">
          <Button
            className={`btn btn-secondary`}
            style={{ marginLeft: currentSet ? 0 : '' }}
            onClick={handleChooseSets}
            text="Изменить комплект"
            icon={'fe-edit-2'}
          />
          <Button
            text="Создать задание"
            icon="fe-check"
            loading={loading}
            disabled={loading}
            onClick={handleSaveTask}
          />
        </div>
      ) : null}
    </>
  );
};

export default DesktopComponent;
